import { ONLY_NUMBERS_REGEX } from '@global/constants/general';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, IconButton, StandardTextFieldProps, TextField, Typography } from '@mui/material';
import React, { forwardRef, useState } from 'react';
import { helperTextRender } from '../utils/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onlyNumbers = (e: any) => {
  e.target.value = e.target.value.replace(!ONLY_NUMBERS_REGEX, '');
};

interface TextfieldProps extends StandardTextFieldProps {
  topLabel?: string;
  type?: string;
  maxLength?: number;
  helperText?: React.ReactNode;
  inputStyle?: React.CSSProperties | undefined;
  helperTextIcon?: string;
}

const StandardTextfield = forwardRef(function MyInput(props: TextfieldProps, ref: any) {
  const {
    topLabel,
    onChange,
    required,
    type = 'text',
    maxLength,
    helperText,
    variant,
    inputStyle,
    helperTextIcon,
    ...rest
  } = props;
  const [typeOfField, setTypeOfField] = useState(type || 'text');

  return (
    <Box>
      {topLabel && (
        <Typography variant="body1" sx={{ fontWeight: '500', mb: '1rem' }}>
          {topLabel}
          {required && '*'}
        </Typography>
      )}
      <TextField
        {...rest}
        type={typeOfField}
        ref={ref}
        required
        variant={variant}
        fullWidth
        helperText={
          typeof helperText !== 'string' ||
          (typeof helperText === 'string' && helperText?.toLowerCase() !== 'required') ? (
            <p>
              {helperTextRender(helperTextIcon)} {helperText}
            </p>
          ) : null
        }
        inputProps={{
          style: inputStyle ?? {
            fontFamily: 'Source Sans 3',
            fontSize: '1.4rem'
          },
          maxLength
        }}
        onChange={(event) => {
          event.target.value = event.target.value.trimStart();
          if (event.target.value !== ' ' && onChange) {
            if (
              type === 'number' &&
              !ONLY_NUMBERS_REGEX.test(event.target.value) &&
              event.target.value !== ''
            ) {
              return;
            }
            if (onChange) {
              onChange(event);
            }
          }
        }}
        InputProps={{
          ...rest.InputProps,
          ...(type === 'password'
            ? {
                endAdornment: (
                  <React.Fragment>
                    <IconButton
                      onClick={() =>
                        setTypeOfField(typeOfField === 'password' ? 'text' : 'password')
                      }>
                      {typeOfField === 'password' ? (
                        <Visibility sx={{ fontSize: '1.85rem' }} />
                      ) : (
                        <VisibilityOff sx={{ fontSize: '1.85rem' }} />
                      )}
                    </IconButton>
                  </React.Fragment>
                )
              }
            : {})
        }}
        onWheel={(e) => {
          (e.target as HTMLInputElement).blur();
        }}
        onInput={(e) => {
          if (type === 'number') {
            onlyNumbers(e);
          }
        }}
      />
    </Box>
  );
});

export default StandardTextfield;
